import { CharValue } from "./statuses";

export type KeyValue = CharValue | "ENTER" | "DELETE";

export const handleKeyDown = (
  event: KeyboardEvent,
  onChar: (value: string) => void,
  onDelete: () => void,
  onEnter: () => void
) => {
  const key = event.key.toUpperCase();

  if (key === "ENTER") {
    event.preventDefault();
    onEnter();
    return;
  }

  if (key === "BACKSPACE" || key === "DELETE") {
    event.preventDefault();
    onDelete();
    return;
  }

  // Check if it's a valid character (A-Z, Æ, Ø, Å)
  if (/^[A-ZÆØÅ]$/.test(key)) {
    event.preventDefault();
    onChar(key);
    return;
  }
};

export const isValidKey = (key: string): key is KeyValue => {
  return /^[A-ZÆØÅ]$/.test(key) || key === "ENTER" || key === "DELETE";
};
